/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qk_MilestoneInputs */

const en_qk_milestone = /** @type {(inputs: Qk_MilestoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Milestone`)
};

const de_qk_milestone = /** @type {(inputs: Qk_MilestoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meilenstein`)
};

/**
* | output |
* | --- |
* | "Milestone" |
*
* @param {Qk_MilestoneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const qk_milestone = /** @type {((inputs?: Qk_MilestoneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qk_MilestoneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_qk_milestone(inputs)
	return en_qk_milestone(inputs)
});